import { ParsedPreset } from '@aibees/shared/definition';
import { Responders } from 'react-beautiful-dnd';
import { DataConfig } from '../types';

export function useOnDragEnd(
  items: ParsedPreset<DataConfig>[],
  onChange: (items: ParsedPreset<DataConfig>[]) => void
) {
  const onDragEnd: Responders['onDragEnd'] = ({
    source,
    destination,
    draggableId,
  }) => {
    if (
      !destination ||
      (destination.droppableId === source.droppableId &&
        destination.index === source.index)
    )
      return;

    const newColumns = [...items];
    newColumns.splice(source.index, 1);
    const draggedElement = items.find(
      (el) => el.id === draggableId
    ) as ParsedPreset<DataConfig>;
    newColumns.splice(destination.index, 0, draggedElement);
    onChange(newColumns);
  };
  return onDragEnd;
}
